var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_archive-slash",
    "data-name": "vuesax/outline/archive-slash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.979,
    height: 126.979,
    viewBox: "0 0 126.979 126.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive-slash",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.955,113.738a3.924,3.924,0,0,1-2.8-1.164,3.992,3.992,0,0,1,0-5.608L106.966,1.151a3.966,3.966,0,1,1,5.608,5.608L6.759,112.574A3.924,3.924,0,0,1,3.955,113.738Z",
    transform: "translate(6.627 6.627)",
    fill: "#d1d9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M45.678,78.251a19.514,19.514,0,0,1-9.312-2.645L1.871,54.072a3.957,3.957,0,1,1,4.18-6.719L40.388,68.78c2.963,1.64,5.926,2.01,7.83.9s3.016-3.862,3.016-7.513V3.968a3.968,3.968,0,0,1,7.936,0v58.2c0,6.508-2.54,11.746-6.931,14.338A12.683,12.683,0,0,1,45.678,78.251Z",
    transform: "translate(54.211 42.115)",
    fill: "#d1d9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.968,102.906A4,4,0,0,1,0,98.937V24.39A24.431,24.431,0,0,1,24.39,0H75.446A24.262,24.262,0,0,1,94.387,9.047a4.018,4.018,0,0,1-.582,5.608,3.95,3.95,0,0,1-5.555-.582,16.406,16.406,0,0,0-12.8-6.137H24.39A16.506,16.506,0,0,0,7.936,24.39V98.937A4,4,0,0,1,3.968,102.906Z",
    transform: "translate(13.597 6.613)",
    fill: "#d1d9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H126.979V126.979H0Z",
    fill: "none",
    opacity: 0
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContracts);
export default __webpack_public_path__ + "static/media/noContracts.9bebcb148cb3342f06d0f819b6805967.svg";
export { ForwardRef as ReactComponent };